__webpack_require__.p = "https://maya-b2b.s3.eu-central-1.amazonaws.com/cicd-builds/main/chat/1763117012074/";